<sh-dropdown
    #dropdown
    [label]="label()"
    [disabled]="disabled() || isDisabled()"
    [attr.mandatory]="mandatory() ? true : null"
    [error]="error()"
    display="label"
    editable
    (input)="handleSearchInput($event)"
    (active-changed)="handleActiveChanged($event)"
>
    <!-- Show selected team as the active item only while not editing -->
    @if (selectedTeam(); as team) {
        @if (!isSearching()) {
            <sh-menu-item
                [label]="getTeamDisplayName(team)"
                [value]="team.id"
                [active]="true"
                (click)="handleClear()"
            ></sh-menu-item>
        }
    }

    <!-- Show search results (excluding the already-selected team when idle) -->
    @if (searchResults().length > 0) {
        @for (team of searchResults(); track team.id) {
            @if (isSearching() || !isTeamActive(team.id)) {
                <sh-menu-item
                    [label]="getTeamDisplayName(team)"
                    [value]="team.id"
                    (click)="handleTeamSelect(team)"
                ></sh-menu-item>
            }
        }
    }

    <!-- Show no results message -->
    @if (!isLoading() && searchResults().length === 0 && searchTerm()) {
        <sh-menu-item label="No teams found" disabled="true"></sh-menu-item>
    }
    @if (!isLoading() && searchResults().length === 0 && !searchTerm() && !selectedTeam()) {
        <sh-menu-item label="No teams found" disabled="true"></sh-menu-item>
    }
</sh-dropdown>
